'use strict';

/** @type {import('./isNaN')} */
module.exports = Number.isNaN || function isNaN(a) {
	return a !== a;
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/math-intrinsics/isNaN.js
// module id = 204
// module chunks = 8